import { BReactComponent } from 'blocks-cloud/b-react-component';
import { IS_B2B_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { selectStatusPage } from 'reactApp/modules/router/router.selectors';
import { ErrorPage } from 'reactApp/sections/ErrorPage/ErrorPage';
import { store } from 'reactApp/store';

export default function () {
    const errorRoot = document.querySelector('#http-error');
    const project = IS_B2B_BIZ_USER ? 'VK WorkDisk' : 'Облако Mail.ru';
    const bodyModifier = 'body_error';

    const errorPage = new BReactComponent({
        ReactComponent: ErrorPage,
        renderMode: 'append',
    });

    const renderErrorPage = (status) => {
        if (!errorRoot) {
            return;
        }

        errorPage.renderTo(errorRoot, { props: { status } });
        $(document.body).addClass(bodyModifier);
        document.title = `${status} / ${project}`;
    };

    store.subscribe(() => {
        const state = store.getState();
        const statusCode = selectStatusPage(state);

        if (statusCode) {
            renderErrorPage(statusCode);
        }
    });
}
